import React from 'react';
import './BlockDescription.less';

export const BlockDescription = ({text}) => {
	return <span className="block-description" dangerouslySetInnerHTML={{__html:text}}></span>
}
